/**
 * Embedded System Configuration
 *
 * This configuration is built directly into the PWA bundle.
 * Any device (mobile, tablet, desktop) opening the app will automatically have
 * these default settings pre-loaded into IndexedDB on first launch without requiring
 * any manual setup or typing from operators.
 *
 * When an Administrator updates settings in the Admin Panel, the new settings are saved
 * to Google Sheets (System_Config tab) and distributed to all client devices automatically.
 */

export interface EmbeddedSystemConfig {
  gas_endpoint_url: string;
  gas_config: {
    key: string;
    webAppUrl: string;
    enabled: boolean;
    autoSync: boolean;
    updatedAt: string;
  };
  line_alert_config: {
    enabled: boolean;
    mode: 'gas_relay' | 'direct_webhook' | 'line_messaging_api' | 'line_notify';
    webhookUrl: string;
    apiToken: string;
    targetId: string;
    gasRelayUrl: string;
    updatedAt: string;
  };
  version: string;
  updatedAt: string;
}

export const EMBEDDED_SYSTEM_CONFIG: EmbeddedSystemConfig = {
  // Master Google Apps Script Web App URL for CNC PM Workshop
  gas_endpoint_url:
    'https://script.google.com/macros/s/AKfycbxBL9_67dFb-2CxwSaOJ7_VfFpGWE9sytnjpEcv8DMD7fiDJzb8OMHhTq7mEJ611z0WEA/exec',

  gas_config: {
    key: 'gas_config',
    webAppUrl:
      'https://script.google.com/macros/s/AKfycbxBL9_67dFb-2CxwSaOJ7_VfFpGWE9sytnjpEcv8DMD7fiDJzb8OMHhTq7mEJ611z0WEA/exec',
    enabled: true,
    autoSync: true,
    updatedAt: '2026-09-11T02:00:00.000Z',
  },

  line_alert_config: {
    enabled: true,
    mode: 'gas_relay',
    webhookUrl: '',
    apiToken: '',
    targetId: '',
    gasRelayUrl:
      'https://script.google.com/macros/s/AKfycbxBL9_67dFb-2CxwSaOJ7_VfFpGWE9sytnjpEcv8DMD7fiDJzb8OMHhTq7mEJ611z0WEA/exec',
    updatedAt: '2026-09-11T02:00:00.000Z',
  },

  version: '1.2.0',
  updatedAt: '2026-09-11T02:00:00.000Z',
};

export function getEmbeddedConfig(): EmbeddedSystemConfig {
  return { ...EMBEDDED_SYSTEM_CONFIG };
}
